import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { EnterpriseService } from "../enterprise.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-user-enterprise-requests",
  templateUrl: "./user-enterprise-requests.component.html",
  styleUrls: ["./user-enterprise-requests.component.sass"],
})
export class UserEnterpriseRequestsComponent implements OnInit {
  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private enterpriseService: EnterpriseService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getAllEnterpriseRequests();
  }

  // ---------- Variables ----------
  page: number = 1;
  itemsPerPage: number = 5;
  totalItems: number = 0;

  // Status Tabs: Pending = 1, Approved = 4, Rejected = 5
  selectedTab: number = 1;

  enterpriseRequests: any[] = [];

  // ---------- Change Tab ----------
  changeTab(tab: number) {
    this.selectedTab = tab;
    this.page = 1; // reset page when changing tabs
    this.getAllEnterpriseRequests();
  }

  // ---------- Get Requests ----------
  getAllEnterpriseRequests() {
    this.spinner.show();

    let data = {
      page: this.page,
      limit: this.itemsPerPage,
      status: this.selectedTab,
    };

    this.enterpriseService.getEnterpriseRequests(data).subscribe(
      (result: any) => {
        this.spinner.hide();

        if (result.statusCode == 200) {
          this.enterpriseRequests = result.data;
          this.totalItems = result.pagination.total;
        } else {
          this.toastr.error(result.message);
          this.enterpriseRequests = [];
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error("Something went wrong");
      }
    );
  }

  // ---------- Pagination ----------
  gty(page) {
    this.page = page;
    this.getAllEnterpriseRequests();
  }

  // ---------- View Details ----------
  viewRequest(id) {
    this.router.navigate(["dashboard/view-enterprise-details"], {
      queryParams: { id: id },
    });
  }
}
